import firebase from "firebase";
import { GET_CONTENT } from "./types";

export const getContent = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("content")
    .onSnapshot((snap) => {
      var content = [];
      snap.docs.forEach((doc) => {
        content.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: GET_CONTENT, content });
    });
};
